import { render, staticRenderFns } from "./CreateAdmin.vue?vue&type=template&id=e5e900d4&scoped=true"
import script from "./CreateAdmin.vue?vue&type=script&lang=js"
export * from "./CreateAdmin.vue?vue&type=script&lang=js"
import style0 from "./CreateAdmin.vue?vue&type=style&index=0&id=e5e900d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e900d4",
  null
  
)

export default component.exports